export var REPORT_DOMAIN = 'apmplus.volces.com';
export var SETTINGS_DOMAIN = REPORT_DOMAIN;
export var SDK_VERSION = process.env.SDK_SLARDAR_VERSION || '';
export var SDK_NAME = 'APM_PLUS_WEB';
export var SETTINGS_PATH = '/settings/get/webpro';
export var BATCH_REPORT_PATH = '/monitor_web/collect';
export var STORAGE_PREFIX = 'APMPLUS';
export var DEFAULT_IGNORE_PATHS = [BATCH_REPORT_PATH, SETTINGS_PATH];
export var DEFAULT_SAMPLE_CONFIG = {
    sample_rate: 1,
    include_users: [],
    sample_granularity: 'session',
    rules: {},
};
export var DEFAULT_SENDER_SIZE = 20;
//# sourceMappingURL=constants.js.map